import React from 'react';
import { SVGIconProps } from '../../domains/common';

const TriangleIcon: React.FC<SVGIconProps> = props => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path fill="currentColor" d="M8 5v14l11-7z" />
    </svg>
  );
};

export default TriangleIcon;
